import React from "react";
import "./StaffingTable.less";
import Tooltip from "@material-ui/core/Tooltip";
import { apiRequest, apiDelete, apiPut } from "../../../../utils/api_service";
import { API_URL } from "../../../../constants/api";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CancelIcon from "@material-ui/icons/Cancel";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import { ShowToast, toastType } from "../../../../utils/toast-service";
import { GetSectionPermission } from "../../../../utils/helper";
import { SECTIONS } from "../../../../constants/appConstants";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel
} from "@material-ui/core";
let StaffMasterListFinal;
let RoleMasterListFinal;

class StaffingTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      staffingTableList: [],
      addNew: false,
      idToEdit: 0,
      SelectedRole: "",
      SelectedName: "",
      SelectedCostCode: "",
      SelectedDescription: "",
      staffAssignmentIDToDelete: 0,
      DeleteDialog: false,
      HoursPerWeek: undefined,
      RefDefaultHours: false
    };
  }

  componentDidMount() {
    const { propertyId, startDate, endDate } = this.props;

    this.GetStaffingDataByDate(propertyId, startDate, endDate);
    StaffMasterListFinal = this.getStaffMasterList();
    this.getRoleMasterList();
  }

  componentWillReceiveProps(newProps) {
    const { propertyId, startDate, endDate } = this.props;

    if (
      newProps.propertyId != propertyId ||
      newProps.startDate != startDate ||
      newProps.endDate != endDate
    ) {
      // console.log(newProps);
      this.GetStaffingDataByDate(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate
      );
    }
  }

  /** dstaffing details by date */
  GetStaffingDataByDate = (propertyId, startDate, endDate) => {
    const params = {
      propertyId: propertyId,
      endDate: endDate,
      startDate: startDate
    };
    apiRequest({
      url: API_URL.reports.StaffingDetailsByMonth,
      params
    }).then(({ data: StaffingSummary }) => {
      this.setState({
        staffingTableList: StaffingSummary
      });
      const { onUpdate } = this.props;
      onUpdate();
    });
  };

  /** call on delete staffing details */
  DeleteStaffingDetails = staffAssignmentID => {
    //if (confirm("Are you sure! You want to delete this record?")) {
    apiDelete({
      url:
        API_URL.reports.DeleteStaffingDetails +
        "?staffAssignmentID=" +
        staffAssignmentID
    }).then(response => {
      response.success == false
        ? ShowToast(
            "Server Error: Unable to delete the record.",
            toastType.ERROR,
            5000,
            500
          )
        : ShowToast(
            "Record deleted successfully.",
            toastType.SUCCESS,
            5000,
            200
          );
      const { propertyId, startDate, endDate } = this.props;

      this.GetStaffingDataByDate(propertyId, startDate, endDate);
    });
    this.setState({ DeleteDialog: false });
    // }
  };

  /** staffing master list */
  getStaffMasterList() {
    apiRequest({
      url: API_URL.reports.StaffMasterList
    }).then(({ data: StaffMasterList }) => {
      StaffMasterListFinal = StaffMasterList;
    });
  }

  /** role masater list */
  getRoleMasterList() {
    apiRequest({
      url: API_URL.reports.RoleMasterList
    }).then(({ data: RoleMasterList }) => {
      RoleMasterListFinal = RoleMasterList;
    });
  }

  /** new row add */
  addNewRow = () => {
    this.setState({});
    this.setState({
      addNew: true,
      idToEdit: 0,
      SelectedRole: "",
      SelectedName: "",
      SelectedCostCode: "",
      SelectedDescription: ""
    });
  };

  /** clear new row */
  clearNewRow = () => {
    this.setState({
      addNew: false
    });
  };

  /** call on handle change */
  handleChange = (e, type) => {
    if (type == "RefDefaultHours") {
      this.setState({
        RefDefaultHours: e.target.checked
      });
      return;
    }

    const value = e.target.value;
    if (type == "WorkHour") {
      this.setState({
        HoursPerWeek: value
      });
    }

    if (type == "Role") {
      const orgRole = RoleMasterListFinal.find(x => x.orgRoleID == value);
      this.setState({
        SelectedRole: value,
        SelectedCostCode: orgRole.costCode,
        SelectedDescription: orgRole.description
      });
    }
    if (type == "Name") {
      this.setState({
        SelectedName: value
      });
    }
  };

  /** save staffing record */
  saveStaffRecord = () => {
    // const postBody = {
    //   staffAssignmentID: this.state.staffAssignmentID,
    //   orgRoleID: this.state.SelectedRole,
    //   staffID: this.state.SelectedName,
    //   // costCode: this.state.SelectedCostCode,
    //   // description: this.state.SelectedDescription,
    //   // allocationPercent: this.state.SelectedAllocation,
    //   // assigned: this.state.SelectedAssigned,
    //   WorkOrderValue: this.state.WorkOrderValue,
    //   propertyID: parseInt(this.props.propertyId),
    //   isAllocated: false,
    //   allocationDate: moment(this.props.startDate)
    //     .endOf("month")
    //     .format(),
    //   createdDate: null,
    //   createdBy: null,
    // };
    const { SelectedName, HoursPerWeek, RefDefaultHours } = this.state;
    const { propertyId, startDate, endDate } = this.props;

    const postBody = {
      staffID: SelectedName,
      propertyID: parseInt(propertyId),
      hoursPerWeek: parseInt(HoursPerWeek),
      refDefaultHours: RefDefaultHours,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD")
    };

    if (!HoursPerWeek) {
      ShowToast("Please fill all fields", toastType.WARNING, 5000, 500);
      return false;
    }

    if (isNaN(HoursPerWeek)) {
      ShowToast(
        "value must be numeric for Default Hours",
        toastType.WARNING,
        5000,
        500
      );
      return false;
    }
    if (parseInt(HoursPerWeek) > 168) {
      ShowToast(
        "value should not be higher than 168 for a week",
        toastType.WARNING,
        5000,
        500
      );
      return false;
    }

    apiPut(API_URL.reports.UpdateStaffingHoursByMonth, postBody).then(
      ({ data: response }) => {
        if (response.success == true) {
          ShowToast(
            "Record updated successfully.",
            toastType.SUCCESS,
            5000,
            500
          );
          // }
          const { propertyId, startDate, endDate } = this.props;
          this.GetStaffingDataByDate(propertyId, startDate, endDate);
          this.setState({
            addNew: false,
            idToEdit: 0,
            SelectedRole: "",
            SelectedName: "",
            SelectedCostCode: "",
            SelectedDescription: "",
            HoursPerWeek: undefined,
            RefDefaultHours: false
          });
        }
      }
    );
  };

  /** edit record */
  editStaffingRecord(id) {
    const { staffingTableList } = this.state;
    const recordToEdit =
      staffingTableList.find(x => x.staffAssignmentID == id) || {};
    this.setState({
      idToEdit: id,
      SelectedRole: recordToEdit.orgRoleID,
      SelectedName: recordToEdit.staffID,
      SelectedCostCode: recordToEdit.costCode,
      SelectedDescription: recordToEdit.description,
      HoursPerWeek: recordToEdit.hoursPerWeek,
      RefDefaultHours: recordToEdit.refDefaultHours
    });
  }

  render() {
    const {
      staffingTableList,
      addNew,
      DeleteDialog,
      staffAssignmentIDToDelete,
      RefDefaultHours,
      HoursPerWeek,
      SelectedName,
      SelectedRole,
      SelectedDescription,
      SelectedCostCode,
      idToEdit
    } = this.state;

    const { propertyId } = this.props;
    const permission = GetSectionPermission(
      SECTIONS.STAFFING,
      SECTIONS.CURRENT_STAFFING_TABLE
    );
    const IsEditable = permission.accessTypeId > 1 ? true : false;
    const element = addNew ? (
      <tr>
        <td>
          <Select
            value={SelectedRole}
            inputProps={{ "aria-label": "Without label" }}
            style={{ minWidth: "120px", fontSize: "13px" }}
            onChange={e => {
              this.handleChange(e, "Role");
            }}
          >
            {(RoleMasterListFinal || []).map((item, index) => (
              <MenuItem key={"RoleMaster" + index} value={item.orgRoleID}>
                {item.role}
              </MenuItem>
            ))}
          </Select>
        </td>
        <td>
          <Select
            value={SelectedName}
            inputProps={{ "aria-label": "Without label" }}
            style={{ minWidth: "120px", fontSize: "13px" }}
            onChange={e => {
              this.handleChange(e, "Name");
            }}
          >
            {(StaffMasterListFinal || []).map((item, index) => (
              <MenuItem key={"StaffMaster" + index} value={item.staffID}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </td>
        <td>
          <TextField
            required
            size={"small"}
            value={SelectedCostCode}
            id={"standard-basic"}
            style={{ minWidth: "120px", fontSize: "13px" }}
            onChange={e => {
              this.handleChange(e, "costCode");
            }}
          />
        </td>
        <td>
          {" "}
          <TextField
            size={"small"}
            required
            value={SelectedDescription}
            id={"standard-basic"}
            style={{ minWidth: "120px", fontSize: "13px" }}
            onChange={e => {
              this.handleChange(e, "description");
            }}
          />
        </td>
        <td />

        <td>
          <Tooltip title={"Save Record"}>
            <IconButton
              aria-label={"Save"}
              className={"staffing-common-button"}
              size={"small"}
            >
              <SaveIcon onClick={this.saveStaffRecord} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Cancel"}>
            <IconButton
              aria-label={"Cancel"}
              title={"Cancel"}
              className={"staffing-common-button"}
              size={"small"}
            >
              <CancelIcon onClick={this.clearNewRow} />
            </IconButton>
          </Tooltip>
        </td>
      </tr>
    ) : null;
    return (
      <>
        <table id={"staffing-table"}>
          <thead>
            <tr className={"blue-custom-title"}>
              <th
                colSpan={propertyId?.length > 1 ? 6 : 6}
                style={{ fontSize: "15px", textAlign: "center" }}
              >
                {"Current Staffing Details\r"}
              </th>
              <th className={"Staffing-table-buttons"}>
                {IsEditable &&
                  (propertyId?.length <= 1 ? (
                    // <Tooltip title="Add New Record">
                    //   <IconButton
                    //     aria-label="Add New"
                    //     className="staffing-add-new"
                    //     size="small"
                    //   >
                    //     <AddBoxIcon onClick={this.addNewRow} />
                    //   </IconButton>
                    // </Tooltip>
                    <></>
                  ) : null)}
              </th>
            </tr>
            {/* <tr>
              <th colSpan={7}>&nbsp;</th>
            </tr> */}

            <tr
              className={"blue-custom-title"}
              style={{ borderTop: "3px solid #FFFFFF" }}
            >
              <th>{"Role"}</th>
              <th>{"Name"}</th>
              <th>{"Work Hours (UltiPro)"}</th>
              <th>{"Over Time Hours (UltiPro)"}</th>
              <th>{"Default Work Hours (Per Week)"}</th>
              {propertyId?.length > 1 ? <th>{"Data Center"}</th> : null}
              <th>{"Apply Default Hours"}</th>
              {propertyId?.length <= 1 ? (
                <th className={"w-10"}> {IsEditable && "Action"}</th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {element}
            {(staffingTableList || []).map((item, index) =>
              idToEdit != item.staffAssignmentID ? (
                <tr key={"staffingTable" + index}>
                  <td>{item.role}</td>
                  <td>{item.name}</td>
                  <td>{item.ultiProWorkHours}</td>
                  <td>{item.ultiProOverTime}</td>
                  <td>{item.hoursPerWeek}</td>

                  {propertyId?.length > 1 ? (
                    <td>{item.dataCenterName}</td>
                  ) : null}
                  <td>{item.refDefaultHours === true ? "Applied" : "-"}</td>
                  {propertyId?.length <= 1 ? (
                    <td>
                      {IsEditable && (
                        <Tooltip title={"Edit Record"}>
                          <IconButton
                            aria-label={"Edit"}
                            className={"staffing-common-button"}
                            size={"small"}
                          >
                            <EditIcon
                              style={{ width: "20px" }}
                              onClick={() =>
                                this.editStaffingRecord(item.staffAssignmentID)}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </td>
                  ) : null}
                </tr>
              ) : (
                <tr>
                  <td>{item.role}</td>
                  <td>{item.name}</td>
                  <td>{item.ultiProWorkHours}</td>
                  <td>{item.ultiProOverTime}</td>
                  <td>
                    <TextField
                      required
                      size={"small"}
                      value={HoursPerWeek}
                      id={"standard-basic"}
                      style={{
                        minWidth: "120px",
                        fontSize: "13px",
                        backgroundColor: "#dfdfdf"
                      }}
                      onChange={e => {
                        this.handleChange(e, "WorkHour");
                      }}
                    />
                  </td>
                  <td>
                    <FormControlLabel
                      id={"isConfigurableControlLabel"}
                      key={"isConfigurableControlLabelKey"}
                      value={RefDefaultHours || false}
                      checked={RefDefaultHours}
                      control={
                        <Checkbox
                          id={"RefDefaultHours"}
                          key={"isRefDefaultHoursCheckbox"}
                          checked={RefDefaultHours}
                          color={"primary"}
                          onChange={event => {
                            this.handleChange(event, "RefDefaultHours");
                          }}
                        />
                      }
                      label={"Apply Default Hours"}
                      labelPlacement={"end"}
                    />
                  </td>
                  <td>
                    <Tooltip title={"Save Record"}>
                      <IconButton
                        aria-label={"Save"}
                        className={"staffing-common-button"}
                        size={"small"}
                      >
                        <SaveIcon onClick={this.saveStaffRecord} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={"Cancel"}>
                      <IconButton
                        aria-label={"Cancel"}
                        className={"staffing-common-button"}
                        size={"small"}
                      >
                        <CancelIcon
                          onClick={() => this.editStaffingRecord(0)}
                        />
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              )
            )}

            {(staffingTableList || []).length <= 0 && addNew == false ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  {"No data available\r"}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
        <Dialog
          open={DeleteDialog}
          // onClose={this.setState({ DeleteDialog: false })}
          aria-labelledby={"alert-dialog-title"}
          aria-describedby={"alert-dialog-description"}
        >
          <DialogTitle id={"alert-dialog-title"}>
            {"Delete Staffing Record"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id={"alert-dialog-description"}>
              {"Are you sure! You want to delete this record?\r"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ DeleteDialog: false });
              }}
              color={"primary"}
            >
              {"Cancel\r"}
            </Button>
            <Button
              onClick={() => {
                this.DeleteStaffingDetails(staffAssignmentIDToDelete);
              }}
              color={"primary"}
              autoFocus
            >
              {"Yes\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default StaffingTable;
